var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-container"},[_c('div',{staticClass:"header-container__details"},[_c('div',{staticClass:"row"},[_c('UserInfo',{ref:"userInfo"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }